export const ADD_BRANCH = "ADD_BRANCH";
export const GET_BRANCHES = "GET_BRANCHES";
export const SET_ORDERS_ACTIVE_PAGE = "SET_ORDERS_ACTIVE_PAGE";
